import { Link, useParams } from "react-router-dom";
import "./Project.css";
import project1 from "../../Projects/FullProject1.png";
import project2 from "../../Projects/FullProject2.JPG";
import project3 from "../../Projects/FullProject3.png";
import project4 from "../../Projects/FullProject4.png";
import project5 from "../../Projects/FullProject5.png";
import project6 from "../../Projects/FullProject6.png";
import gsap from "gsap";
import { useEffect, useState } from "react";
var Project = function () {
  const [imageURL, setImageURL] = useState()
  const [title, setTitle] = useState('')
  let { id } = useParams();
  useEffect(() => {
    console.log("Aaya to hai",);
    if (id === '1') {
      setImageURL(project1)
      setTitle('Warehouse Store')
    }
    else if (id === '2') {
      setImageURL(project2)
      setTitle('PS 5')
    }
    else if (id === '3') {
      setImageURL(project3)
      setTitle('Gym Store')
    }
    else if (id === '4') {
      setImageURL(project4)
      setTitle('Electroic Shop')
    }
    else if (id === '5') {
      setImageURL(project5)
      setTitle('Travel Blog')
    }
    else if (id === '6') {
      setImageURL(project6)
      setTitle('Petroleum Company')
    }
  }, [id])
  console.log(id, imageURL);
  useEffect(() => {
    const tl = gsap.timeline();
    tl.from(".wordOUT", { duration: 1, opacity: 0, y: "-100%" }, 1);
    tl.from(".wordMAIN", { duration: 1, opacity: 0, y: "100%" }, 1);
    tl.from("#ProjectsTwo", {
      duration: 1,
      opacity: 0,
      y: '60vh',
    });
  }, []);
  return (
    <div>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Work</title>
      <link
        rel="stylesheet"
        type="text/css"
        id="applicationStylesheet"
        href="Work.css"
      />
      <div id="Project">
        <div id="menu">
          <div id="menu_text">
            <span className="menuItems">
              <Link to="/">Home</Link>
            </span>
            <span className="menuItems">
              <Link to="/about">About</Link>
            </span>
            <span className="menuItems" style={{ fontSize: "2rem" }}>
              <Link to="/work">Works</Link>
            </span>
            <span className="menuItems">
              <Link to="/contact">Contact</Link>
            </span>
          </div>
        </div>
        <div id="Work_be">
          <span className="wordMAIN">{title}</span>
        </div>

        <div id="ProjectsTwo">
          <div className="projectBlocksTwo">
            <img src={imageURL} alt='project' className='projectImagesTwo' />
          </div>

        </div>
      </div>
    </div>
  );
};
export default Project;
